<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <div class="set-item">
                <el-checkbox v-model="submitData.invenData" border="" class="item-canset"></el-checkbox>
                <el-tag
                    class="item-cname2"
                    type="danger"
                    effect="plain"
                >将所有商品的库存数初始化为 0 （所有仓位下的库存数也会初始化为 0）</el-tag>
            </div>
        </div>
        <div
            slot="footer"
            class="dialog-footer"
            style="text-align: right; margin-top: 20px; padding-bottom: 10px"
        >
            <el-button class="search-btn" size="small" @click="closeDialog()">取消</el-button>
            <el-button class="search-btn" size="small" type="warning" @click="submit">初始化选中项</el-button>
        </div>
        <el-progress
            v-if="saveLoading"
            class="saveProgress"
            type="circle"
            :percentage="percentage"
        />
    </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      loading: false,
      submitData: {
        invenData: false
      },
      percentage: 0,
      saveCount: 0,
      saveLoading: false
    };
  },
  mounted() {},
  methods: {
    submit() {
      let that = this;
      if (!that.submitData.invenData) {
        that.$util.warningMsg("您未选中要初始化的数据项");
        return;
      }
      that
        .$confirm(
          "您确定初始化选中的数据吗？一旦初始化，将无法进行恢复！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: false
          }
        )
        .then(() => {
          that.loading = true;
          that.$util
            .axiosPost({
              url: "/api/EntpInfoManagement/GetInitialDatasCount",
              data: that.submitData,
              hideLoading: true
            })
            .then(res => {
              if (res.errcode == 0 && res.data > 0) {
                let total = res.data;
                if (total > 0) {
                  that.saveLoading = true;
                  that.loopClear(total);
                }
              } else {
                that.$util.errorMsg(res.errmsg);
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    async loopClear(total) {
      const { data } = await this.$util.axiosPost({
        url: "/api/EntpInfoManagement/InitialDatas",
        data: this.submitData,
        hideLoading: true
      });
      this.saveCount += 200;
      let num = parseFloat(this.saveCount);
      this.percentage = Math.ceil(Math.round((num / total) * 10000) / 100);
      this.percentage = this.percentage > 100 ? 100 : this.percentage;

      let _stop = this.saveCount >= total;
      if (_stop) {
        this.saveLoading = false;
        this.loading = false;
        this.closeDialog();
      } else {
        this.loopClear(total);
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>
<style lang="less" scope>
.set-content {
  display: flex;
  flex-direction: column;

  .set-item {
    display: flex;
    flex-direction: row;
    height: 40px;

    .item-canset {
      width: 7%;
      border-radius: 5px 0 0 5px;
    }

    .item-cname2 {
      width: 93% !important;
    }
  }
  .el-input-group__prepend {
    padding: 0 10px;
    border-radius: 0;
  }
  .el-input-group__append {
    padding: 0 10px;
  }
  .el-input__inner {
    border-radius: 0;
  }
  .el-button {
    border-radius: 0;
  }
  .el-tag {
    height: 100%;
    width: 100%;
    border-radius: 0 5px 5px 0;
    font-size: 14px;
    line-height: 35px;
  }
  .item-sep {
    display: flex;
    flex-direction: row;
    height: 40px;
    margin-top: 30px;

    .item-canset {
      width: 7%;
      border-radius: 5px 0 0 5px;
    }

    .el-input__inner {
      border-radius: 0 5px 5px 0;
    }
  }
  .sep-info {
    margin-top: 10px;
    color: rgb(155, 153, 153);
  }
}
.saveProgress {
  position: absolute;
  top: 45%;
  left: 45%;
  z-index: 99999;
}
</style>
<style lang="less">
.set-content {
  .el-checkbox {
    border: 1px solid #fbc4c4;
  }
}
</style>
